var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',{attrs:{"aspect-ratio":16 / 9}},[_c('iframe',{attrs:{"id":"video-mae-elenials-iframe","title":"Vídeo Youtube","frameborder":"0","width":"100%","height":"100%","src":_vm.urlVideoYoutube}})])}
var staticRenderFns = []

export { render, staticRenderFns }